import React from 'react';
import AnimatedPageContainer from '../../../assets/containers/AnimatedPageContainer';
import classes from '../styles/style.module.css'

const HubblePageContainer = ({ children }) => {
    return (
        <AnimatedPageContainer>
            <section className={classes.pageContainer}
            >
                <div className='customContainer' >
                    {children}
                </div>
                <div className={classes.vectorContainer}>
                    <img src='/images/hubble/hubbleBgVector.png' className={classes.firstbgImg} />
                    <img src='/images/hubble/hubbleBgVector2.jpg' className={classes.secondbgImg} />
                </div>
            </section>
        </AnimatedPageContainer>
    )
}

export default HubblePageContainer